import script from "./WeightedCloseIndicator.vue?vue&type=script&lang=js"
export * from "./WeightedCloseIndicator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__